var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.header)?_c('Header',{attrs:{"type":_vm.type,"keyword":_vm.keyword}}):_vm._e(),_c('router-view',{on:{"searchTarget":_vm.handleSearch,"barTarget":_vm.handleBar}}),(_vm.footer)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }